import {
    FormPart,
} from 'app/types/form.types'

import {
    ContactsSelection,
} from './PrintForm.types'

const getContactSelectionFields = ({
    value,
    disabledAll,
}: {
    value: ContactsSelection,
    disabledAll: boolean,
}): FormPart<keyof ContactsSelection>[] => {
    return [{
        title: 'Contact Selection',
        className: 'contacts',
        fields: [
            {
                id: 'contact-selection-col-1',
                fields: [{
                    name: 'skyCellContact',
                    componentName: 'UserObjectSelector',
                    required: true,
                    labelKey: 'AccountQuotes.skycellContact',
                }],
            },
            {
                id: 'contact-selection-col-2',
                fields: [{
                    name: 'customerQuotationContact',
                    componentName: 'ContactObjectSelector',
                    label: 'Customer Quotation Contact',
                    disabled: Boolean(value.customerExecutionContact) || disabledAll,
                }],
            },
            {
                id: 'contact-selection-col-3',
                fields: [{
                    name: 'customerExecutionContact',
                    componentName: 'ContactObjectSelector',
                    label: 'Customer Execution Contact',
                    disabled: Boolean(value.customerQuotationContact) || disabledAll,
                }],
            },
        ],
    }]
}

export default getContactSelectionFields
